module.exports = __webpack_public_path__ + "78d5256e78f40323fe91a69bb0aae300.svg";